import { render, staticRenderFns } from "./BlogBox.vue?vue&type=template&id=51722d26&"
import script from "./BlogBox.vue?vue&type=script&lang=js&"
export * from "./BlogBox.vue?vue&type=script&lang=js&"
import style0 from "./BlogBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports